<template>
  <a-modal
    v-model="show"
    :width="700"
    title="全员优惠寄件"
  >
    <div class="t-center">
      <div class="fs-24 fs-b">送您200元电子运费券<br>
        连续20天每天领取，寄的多省的多！
      </div>
      <div class="mt-10">活动有效期：2020.07.15-07.31</div>
    </div>
    <div class="t-center mt-10 pointer" @click="$router.push('/main/send')"><img class="w-500" src="/assets/index/2quan@2x.png" alt=""></div>
    <div class="t-center  mt-10 pointer" @click="$router.push('/main/send')"><img class="w-500" src="/assets/index/3quan@2x.png" alt=""></div>
    <div class="t-center mt-10 pointer" @click="$router.push('/main/send')"><img class="w-500" src="/assets/index/5quan@2x.png" alt=""></div>
    <div class="t-center mt-10">今日登录已领取3张优惠券（合计面值10元）<a-button type="link" @click="$router.push('/main/manager/order')">查看全部电子运费券</a-button></div>
    <div slot="footer">
      <a-button @click="show = false">取消</a-button>
      <a-button type="primary" @click="$router.push('/main/send')">去使用</a-button>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    viz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: this.viz
    }
  },
  watch: {
    show(n) {
      this.$emit('update:viz', n)
    },
    viz(n) {
      this.show = n
    }
  }
}
</script>
<style lang="scss" scoped>
.c-tips{
    position: relative;
    .close{
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
}
</style>
